<div class="custom-dialog-overlay" *ngIf="dialogService.dialogVisible">
    <div class="custom-dialog-box">
        <!-- Header -->
        <div class="custom-dialog-header">
            <span class="header-text"><i [class]="'bi ' + dialogService.iconType"></i>&nbsp;{{ dialogService.header }}</span>
        </div>

        <!-- Content -->
        <div class="custom-dialog-content">
            {{ dialogService.content }}
        </div>

        <!-- Footer -->
        <div class="custom-dialog-footer text-center">
            <!-- Confirm Button (conditionally visible) -->
            <button *ngIf="dialogService.showConfirmButton" type="button" class="btn btn-success dialog-confirm-btn" (click)="onConfirm()">Ok</button>

            <!-- Close Button -->
            <button type="button" *ngIf="dialogService.showCloseButton" class="btn btn-primary dialog-close-btn" (click)="dialogService.hideDialog()">Close</button>
        </div>
    </div>
</div>